import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import RequestDemo from "@/pages/RequestDemo";
import MarketingPage from "@/pages/marketing/MarketingPage";
import { MARKETING } from "@/data/marketing";

import DashboardLayout from "@/components/dashboard/DashboardLayout";
import Dashboard from "@/pages/dashboard/Dashboard";
import Patients from "@/pages/dashboard/Patients";
import PatientDetail from "@/pages/dashboard/PatientDetail";
import Schedule from "@/pages/dashboard/Schedule";
import Telehealth from "@/pages/dashboard/Telehealth";
import CareTeam from "@/pages/dashboard/CareTeam";
import Messages from "@/pages/dashboard/Messages";
import Assessments from "@/pages/dashboard/Assessments";
import TreatmentPlans from "@/pages/dashboard/TreatmentPlans";
import ParentPortal from "@/pages/dashboard/ParentPortal";
import SchoolIEP from "@/pages/dashboard/SchoolIEP";
import Analytics from "@/pages/dashboard/Analytics";
import ResourcesApp from "@/pages/dashboard/ResourcesApp";
import Settings from "@/pages/dashboard/Settings";

function ScrollTop() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/request-demo" element={<RequestDemo />} />
          <Route path="/solutions" element={<MarketingPage {...MARKETING.solutions} />} />
          <Route path="/for-families" element={<MarketingPage {...MARKETING.families} />} />
          <Route path="/for-providers" element={<MarketingPage {...MARKETING.providers} />} />
          <Route path="/resources" element={<MarketingPage {...MARKETING.resources} />} />
          <Route path="/about" element={<MarketingPage {...MARKETING.about} />} />

          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/patients" element={<Patients />} />
            <Route path="/patients/:id" element={<PatientDetail />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/telehealth" element={<Telehealth />} />
            <Route path="/care-team" element={<CareTeam />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/assessments" element={<Assessments />} />
            <Route path="/treatment-plans" element={<TreatmentPlans />} />
            <Route path="/parent-portal" element={<ParentPortal />} />
            <Route path="/school-iep" element={<SchoolIEP />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/app-resources" element={<ResourcesApp />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
